"use strict";import{IconDash100 as e}from"../src/elements/IconDash100.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-icon-dash100",e);
//# sourceMappingURL=sp-icon-dash100.js.map
